/** @format */

import React, { useEffect, useState, Suspense, lazy } from 'react';
import Cookies from 'js-cookie';
import {
	BrowserRouter,
	Routes,
	Route,
	Navigate,
	useSearchParams,
} from 'react-router-dom';

import { NProvider } from './Elements/Navbar/NavbarContext';
import Layout from './helper/Layout';
import useAuth from './hooks/useAuth';
import AuthContext from './Context/AuthContext';
import ProtectedRoutes from './Context/ProtectRoutes';
import FallbackLoading from './Elements/Misc/FallbackLoading';

const DashBoard = lazy(() => import('./screens/DashBoard/DashBoard'));
const FilterContext = lazy(() =>
	import('./Context/FilterContext/FilterContext')
);

const LoginScreen = lazy(() => import('./screens/Auth/Login'));
const SignUpScreen = lazy(() => import('./screens/Auth/Singup'));
const Verify = lazy(() => import('./screens/Auth/Verify'));
const TermsConditions = lazy(() => import('./screens/Auth/Terms'));
const TeamSignUp = lazy(() => import('./screens/Auth/TeamSignup'));
const ForgotPassword = lazy(() => import('./screens/Auth/ForgotPassword'));
const ResetPassword = lazy(() => import('./screens/Auth/ResetPassword'));
const PlansScreen = lazy(() => import('./screens/Plans/Plans'));
const APIScreen = lazy(() => import('./screens/API/APIScreen'));
const IntegrationScreen = lazy(() =>
	import('./screens/Integrations/Integrations')
);

const Campaign = lazy(() => import('./screens/Campaign/Campaign'));
const AddCampaign = lazy(() => import('./screens/Campaign/AddCampaign'));
const AddDelivery = lazy(() => import('./screens/Campaign/AddDelivery'));
const EditDelivery = lazy(() => import('./screens/Campaign/EditDelivery'));

const RFP = lazy(() => import('./screens/RFP/RFP'));
const AddRFP = lazy(() => import('./screens/RFP/AddRFP'));

const Tickets = lazy(() => import('./screens/Tickets/Tickets'));
const AddTicket = lazy(() => import('./screens/Tickets/AddTicket'));

const Profile = lazy(() => import('./screens/Profile/Profile'));
const FailedScreen = lazy(() => import('./screens/Misc/Failed'));
const SuccessScreen = lazy(() => import('./screens/Misc/Success'));
const LinkScreen = lazy(() => import('./screens/Misc/LinkIssues'));
const ScreenSizeAlert = lazy(() => import('./screens/Misc/ScreenSizeAlert'));
const NotFound = lazy(() => import('./screens/Misc/NotFound'));

const UserNavigate = () => {
	const [searchParams] = useSearchParams();
	const planId = searchParams.get('planId') || '';
	const type = searchParams.get('type') || '';
	const token = Cookies.get('token');
	useEffect(() => {
		if (type && planId && token?.length > 20) {
			window.location =
				'/thankyou?planId=' +
				planId +
				`&isAnnual=${type === 'year' ? 'true' : 'false'}` +
				'&token=' +
				token;
		}
	}, []);
	return <></>;
};

const AllRoutes = () => {
	const { auth } = useAuth();
	const [screenSize, setScreenSize] = useState(false);

	useEffect(() => {
		const handleContextmenu = (e) => {
			e.preventDefault();
		};
		document.addEventListener('contextmenu', handleContextmenu);
		return function cleanup() {
			document.removeEventListener('contextmenu', handleContextmenu);
		};
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setScreenSize(window.innerWidth < 1000);
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const renderComponent = (DesktopComponent) => {
		return screenSize ? <ScreenSizeAlert /> : <DesktopComponent />;
	};

	return (
		<>
			<BrowserRouter>
				<UserNavigate />
				<FilterContext>
					<NProvider>
						<AuthContext>
							<Suspense fallback={<FallbackLoading />}>
								<Routes>
									<Route path='/' element={<Layout />}>
										<Route
											path='/'
											element={
												auth ? <Navigate to='/campaign' /> : <LoginScreen />
											}
										/>
										{/* <Route
											path='/signUp'
											element={
												auth ? (
													<Navigate to='/contactsearch' />
												) : (
													<SignUpScreen />
												)
											}
										/>
										<Route
											path='/email'
											element={auth ? <Navigate to='/profile' /> : <Verify />}
										/> */}
										<Route
											path='/forgotpassword'
											element={
												auth ? <Navigate to='/profile' /> : <ForgotPassword />
											}
										/>
										<Route
											path='/terms-conditions'
											element={<TermsConditions />}
										/>
										<Route
											path='/resetpassword/:id'
											element={<ResetPassword />}
										/>
										<Route
											path='/teamSignUp'
											element={
												auth ? <Navigate to='/profile' /> : <TeamSignUp />
											}
										/>
										<Route path='/thankyou' element={<SuccessScreen />} />
										<Route path='/failed' element={<FailedScreen />} />
										<Route path='/link' element={<LinkScreen />} />

										{/* Private Routes */}
										<Route element={<ProtectedRoutes />}>
											<Route path='/dashboard' element={<DashBoard />} />
											{/* <Route
											path='/contactsearch'
											element={renderComponent(ContactSearch)}
										/> */}
											{/* <Route path='/mylist' element={renderComponent(MyLists)} /> */}
											{/* <Route
												path='/billing'
												element={renderComponent(BillingScreen)}
											/>
											<Route path='/api' element={<APIScreen />} />
											<Route
												path='/integrations'
												element={<IntegrationScreen />}
											/>
											<Route path='/plans' element={<PlansScreen />} />
											<Route path='/tools' element={<MyTools />} /> */}
											<Route path='/campaign' element={<Campaign />} />
											<Route path='/campaign/add' element={<AddCampaign />} />
											<Route
												path='/campaign/delivery/:id'
												element={<AddDelivery />}
											/>
											<Route
												path='/campaign/update/delivery/:id/:delId'
												element={<EditDelivery />}
											/>

											<Route path='/rfp' element={<RFP />} />
											<Route path='/rfp/add' element={<AddRFP />} />

											<Route path='/tickets' element={<Tickets />} />
											<Route path='/ticket/add' element={<AddTicket />} />

											<Route path='/myprofile' element={<Profile />} />
											<Route path='*' element={<NotFound />} />
										</Route>
									</Route>
								</Routes>
							</Suspense>
						</AuthContext>
					</NProvider>
				</FilterContext>
			</BrowserRouter>
		</>
	);
};

export default AllRoutes;
